import React, { useState, useEffect, useRef } from "react";
import { RiArrowDropDownLine } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import { addToCart, getCartCount } from "../../utils/cartUtils";
import {
  FaMapMarkerAlt,
  FaTimes,
  FaHeart,
} from "react-icons/fa";
import { FiHeart } from "react-icons/fi";
import axios from "axios";
import { X } from "lucide-react";
import { addToWishlist, removeFromWishlist, getWishlistProducts } from "../../utils/wishlistUtils";
import { IoEyeSharp } from "react-icons/io5";
import { Helmet } from "react-helmet-async";
import { RxCross1 } from "react-icons/rx";


const ProductDetail3 = ({ data }) => {
  const productsDetails = data["get_products_details"][0];
  const productImages = data["get_products_details"][0]["product_images"];
  const sizes = data["get_products_details"][0]["size"];
  const sizePrice = data["get_products_details"][0]["get_price_lists"];
  const colors = data["color_products_lists"];
  const allProducts = data["get_similar_product_lists"];
  const isCustomizable =
    data["get_products_details"][0]["Customizable"] === "Yes";
  const [selectedSizeId, setSelectedSizeId] = useState(null);
  const navigate = useNavigate();
  const app_type_id = sessionStorage.getItem("app_type_id");
  const admin_auto_id = sessionStorage.getItem("admin_auto_id");

  const [isOpen, setIsOpen] = useState(true);
  const closeModal = () => setIsOpen(false);

  // State for testimonials slider
  const [reviews, setReviews] = useState([]);
  const [currentReviewIndex, setCurrentReviewIndex] = useState(0);
  const sliderRef = useRef(null);
  const [touchStartX, setTouchStartX] = useState(null);
  const [touchEndX, setTouchEndX] = useState(null);

  const [themeColor, setThemeColor] = useState("#000000")
  const [themeIconColor, setThemeIconColor] = useState("#000000");
  const [webFont, setWebFont] = useState("");
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);
      setWebFont(parsedStyle.web_font);
    }
  }, []);


  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }




  // Slider navigation functions
  const nextReview = () => {
    const reviewsPerPage = window.innerWidth >= 768 ? 3 : 1;
    setCurrentReviewIndex((prevIndex) =>
      prevIndex + reviewsPerPage >= reviews.length
        ? 0
        : prevIndex + reviewsPerPage
    );
  };

  const prevReview = () => {
    const reviewsPerPage = window.innerWidth >= 768 ? 3 : 1;
    setCurrentReviewIndex((prevIndex) =>
      prevIndex - reviewsPerPage < 0
        ? Math.max(
          0,
          reviews.length - (reviews.length % reviewsPerPage || reviewsPerPage)
        )
        : prevIndex - reviewsPerPage
    );
  };

  const goToReview = (index) => {
    const reviewsPerPage = window.innerWidth >= 768 ? 3 : 1;
    setCurrentReviewIndex(index * reviewsPerPage);
  };

  const reviewsPerPage = window.innerWidth >= 768 ? 3 : 1;
  const totalPages = Math.ceil(reviews.length / reviewsPerPage);

  // Touch events for sliding
  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEndX(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStartX && touchEndX) {
      const diff = touchStartX - touchEndX;
      const reviewsPerPage = window.innerWidth >= 768 ? 3 : 1;

      if (diff > 50) {
        // Swipe left - next
        setCurrentReviewIndex((prevIndex) =>
          prevIndex + reviewsPerPage >= reviews.length
            ? 0
            : prevIndex + reviewsPerPage
        );
      } else if (diff < -50) {
        // Swipe right - prev
        setCurrentReviewIndex((prevIndex) =>
          prevIndex - reviewsPerPage < 0
            ? Math.max(
              0,
              reviews.length -
              (reviews.length % reviewsPerPage || reviewsPerPage)
            )
            : prevIndex - reviewsPerPage
        );
      }
    }
    setTouchStartX(null);
    setTouchEndX(null);
  };

  //const [selectedSize, setSelectedSize] = useState(null); // State to track the selected size
  const [mainImage, setMainImage] = useState(productImages[0]);

  // State for dropdown toggling
  const [isShippingOpen, setIsShippingOpen] = useState(false);
  const [isRefundOpen, setIsRefundOpen] = useState(false);
  const [isCustomizeOpen, setIsCustomizeOpen] = useState(false);

  const [zoom, setZoom] = useState(false);
  const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });


  const [selectedSize, setSelectedSize] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(
    productsDetails.final_product_price
  );
  const [currentOffer, setCurrentOffer] = useState(
    productsDetails.offer_percentage
  );
  const [originalPrice, setOriginalPrice] = useState(
    productsDetails.product_price
  );
  const [pincode, setPincode] = useState(
    sessionStorage.getItem("userPincode") || ""
  );
  const [message, setMessage] = useState("");
  const [messageColor, setMessageColor] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSizeSelect = (size, index) => {
    setSelectedSize(size.size_name);
    setSelectedSizeId(size.size_auto_id);
    const selectedPrice = sizePrice[index];
    if (selectedPrice) {
      setCurrentPrice(selectedPrice.final_size_price);
      setOriginalPrice(selectedPrice.size_price);
      setCurrentOffer(selectedPrice.offer_percentage);
    }
  };

  const [chartImage, setChartImage] = useState(null);
  const [chartImage2, setChartImage2] = useState(null);
  const [isSizeGuideModalOpen, setIsSizeGuideModalOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Size Chart");
  const toggleSizeGuideModal = () =>
    setIsSizeGuideModalOpen(!isSizeGuideModalOpen);


  const [cartMessage, setCartMessage] = useState({ text: "", type: "" });
  const [isVibrating, setIsVibrating] = useState(false);
  const [wishlistMessage, setWishlistMessage] = useState({ text: "", type: "" });

  useEffect(() => {
    if (cartMessage.text) {
      const timer = setTimeout(() => {
        setCartMessage({ text: "", type: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [cartMessage.text])

  useEffect(() => {
    const syncWishlistStatus = async () => {
      const token = sessionStorage.getItem("accessToken");

      if (!token || !productsDetails?.product_auto_id) {
        setWishlisted(false);
        return;
      }

      try {
        const wishlistArray = await getWishlistProducts();

        const isWishlisted = wishlistArray.some(
          (item) =>
            String(item.product_auto_id) ===
            String(productsDetails.product_auto_id)
        );

        setWishlisted(isWishlisted);
      } catch (error) {
        console.error("Wishlist sync failed:", error);
      }
    };

    syncWishlistStatus();
  }, [productsDetails.product_auto_id]);

  useEffect(() => {
    if (wishlistMessage.text) {
      const timer = setTimeout(() => {
        setWishlistMessage({ text: "", type: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [wishlistMessage.text]);

  const [wishlisted, setWishlisted] = useState(false);


  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.pageX - left - window.scrollX) / width) * 100;
    const y = ((e.pageY - top - window.scrollY) / height) * 100;
    setZoomPosition({ x, y });
  };

  const toggleZoom = () => setZoom(!zoom);


  const handleWishlistToggle = async (e) => {
    e.preventDefault();
    setIsVibrating(false);
    setWishlistMessage({ text: "", type: "" });
    try {
      if (wishlisted) {
        const res = await removeFromWishlist(productsDetails.product_auto_id);
        if (res?.status === 1) {
          setWishlisted(false);
        } else if (res?.triggerVibration) {
          setIsVibrating(true);
          setTimeout(() => setIsVibrating(false), 600);
          if (!sessionStorage.getItem("accessToken")) {
            setWishlistMessage({ text: "Please sign in to add to wishlist", type: "error" });
          }
        }
      } else {
        const res = await addToWishlist(productsDetails.product_auto_id);
        if (res?.status === "1") {
          setWishlisted(true);
        } else if (res?.triggerVibration) {
          setIsVibrating(true);
          setTimeout(() => setIsVibrating(false), 600);
          if (!sessionStorage.getItem("accessToken")) {
            setWishlistMessage({ text: "Please sign in to add to wishlist", type: "error" });
          }
        }
      }
    } catch (error) {
      console.error("Wishlist error:", error);
    }
  };

  // Fetch reviews and ratings
  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/Show-Ratings`,
          {
            product_auto_id: productsDetails.product_auto_id,
            admin_auto_id: admin_auto_id,
            app_type_id: app_type_id,
          }
        );

        if (response.data.status === 1) {
          setReviews(response.data.getalldata);
        }
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };

    fetchReviews();
  }, [productsDetails.product_auto_id, admin_auto_id, app_type_id]);

  useEffect(() => {
    const fetchSizeChart = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_size_chart_list`,
          {
            admin_auto_id,
            app_type_id,
          }
        );

        if (response.data.status === "1") {
          const list = response.data.getalldata || [];

          // ✅ find normal size chart
          const normalChart = list.find(
            item => item.chart_image && item.chart_image.trim() !== ""
          );

          // ✅ find international size chart
          const internationalChart = list.find(
            item =>
              item.international_size_chart &&
              item.international_size_chart.trim() !== ""
          );

          if (normalChart) {
            setChartImage(
              `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${normalChart.chart_image}`
            );
          }

          if (internationalChart) {
            setChartImage2(
              `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${internationalChart.international_size_chart}`
            );
          }
        }
      } catch (error) {
        console.error("Failed to load size chart:", error);
      }
    };

    fetchSizeChart();
  }, [admin_auto_id, app_type_id]);


  useEffect(() => {
    if (isSizeGuideModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Clean up when component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isSizeGuideModalOpen]);

  const handleCheckPincode = async (pin) => {
    setLoading(true);
    setMessage("");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_pincode_list`,
        {
          admin_auto_id: admin_auto_id,
          user_auto_id: admin_auto_id,
        }
      );

      if (response.data.status === 1) {
        const pincodeList = response.data.get_pincode_list.map(
          (item) => item.pincode
        );
        if (pincodeList.includes(pin.trim())) {
          setMessage(`Good news! We deliver to ${pin}.`);
          setMessageColor("text-green-600");
        } else {
          setMessage(`Sorry, currently we are unable to deliver at ${pin}.`);
          setMessageColor("text-red-600");
        }
      } else {
        setMessage("Failed to fetch delivery data.");
        setMessageColor("text-red-600");
      }
    } catch (error) {
      console.error("Error checking pincode:", error);
      setMessage("Something went wrong. Please try again.");
      setMessageColor("text-red-600");
    } finally {
      setLoading(false);
    }
  };

  // Updated useEffect for automatic pincode checking
  useEffect(() => {
    if (pincode && pincode.length >= 6 && pincode.length <= 8) {
      handleCheckPincode(pincode);
    } else if (pincode && (pincode.length < 6 || pincode.length > 8)) {
      sessionStorage.removeItem("userPincode");
      setPincode("");
    }
  }, []); // Run only on mount

  // Updated pincode input handler
  const handlePincodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Allow only digits
    setPincode(value);
    if (value.length >= 6 && value.length <= 8) {
      handleCheckPincode(value);
    } else if ((value.length < 6 || value.length > 8) && message) {
      setMessage(""); // Clear message if pincode is invalid
      setMessageColor("");
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedImage(file);
      const reader = new FileReader();
      reader.onload = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setUploadedImage(null);
    setImagePreview(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const [uploadedImage, setUploadedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);


  // Function to format SKU to exactly 8 characters using only product_model_auto_id
  const formatSKU = (modelId) => {
    const rawSKU = modelId ? modelId.toString() : '';
    if (rawSKU.length > 8) {
      return rawSKU.slice(0, 8);
    }
    return rawSKU.padEnd(8, '0');
  };


  const [isBoughtFactual, setIsBoughtFactual] = useState(false);
  const [isProductViewsFactual, setIsProductViewsFactual] = useState(false);
  const [isQuantityLeftFactual, setIsQuantityLeftFactual] = useState(false);
  const [quantityLeftFactualValue, setQuantityLeftFactualValue] = useState(1);

  // State to control which messages to show
  const [showMessages, setShowMessages] = useState(false);
  const [showBought, setShowBought] = useState(false);
  const [showViews, setShowViews] = useState(false);
  const [showStock, setShowStock] = useState(false);
  const [randomStocks, setRandomStocks] = useState([]);

  const [isMarketingKeysLoading, setIsMarketingKeysLoading] = useState(true);

  useEffect(() => {
    const fetchMarketingKeys = async () => {
      setIsMarketingKeysLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_marketing_keys`,
          {
            admin_auto_id,
            app_type_id,
          }
        );

        if (response.data.status === "1" && response.data.data.length > 0) {
          const apiData = response.data.data[0];
          setIsBoughtFactual(apiData.is_bought_factual);
          setIsProductViewsFactual(apiData.is_product_views_factual);
          setIsQuantityLeftFactual(apiData.is_quantity_left_factual);
          setQuantityLeftFactualValue(apiData.quantity_left_factual_value);
        } else {
          console.error("Failed to fetch marketing keys:", response.data.msg);
        }
      } catch (error) {
        console.error("Error fetching marketing keys:", error);
      } finally {
        setIsMarketingKeysLoading(false);
      }
    };

    fetchMarketingKeys();
  }, [admin_auto_id, app_type_id]);

  useEffect(() => {
    if (isMarketingKeysLoading) {
      console.log("Waiting for marketing keys to load...");
      return;
    }

    const shouldShowMessages = Math.random() < 0.9;
    setShowMessages(shouldShowMessages);

    if (shouldShowMessages) {
      const randomChoice = Math.random();
      if (randomChoice < 0.33) {
        setShowBought(true);
        setShowViews(false);
      } else if (randomChoice < 0.66) {
        setShowBought(false);
        setShowViews(true);
      } else {
        setShowBought(true);
        setShowViews(true);
      }
    } else {
      setShowBought(false);
      setShowViews(false);
    }

    const shouldShowStock = Math.random() < 0.9;
    setShowStock(shouldShowStock);

    if (shouldShowStock) {
      const stock = parseInt(quantityLeftFactualValue, 10);

      if (isNaN(stock) || stock <= 0) {
        setRandomStocks(sizes.map(() => 0));

      } else {
        const newRandomStocks = sizes.map(() => Math.floor(Math.random() * stock) + 1);
        setRandomStocks(newRandomStocks);

      }
    } else {
      const originalStocks = sizes.map((size) => parseInt(size.size_stock, 10));
      setRandomStocks(originalStocks);

    }
  }, [productsDetails.available_stock, sizes, quantityLeftFactualValue, isMarketingKeysLoading]);


  const getRandomBoughtCount = (count) => {
    const base = parseInt(count) || 0;
    const lower = Math.floor(base * 0.8);  // -20%
    const upper = Math.ceil(base * 1.2);   // +20%
    return Math.floor(Math.random() * (upper - lower + 1)) + lower;
  };

  const getRandomViewCount = (count) => {
    const base = parseInt(count) || 0;
    const lower = Math.floor(base * 0.8);  // -20%
    const upper = Math.ceil(base * 1.2);   // +20%
    return Math.floor(Math.random() * (upper - lower + 1)) + lower;
  };

  const [boughtCount, setBoughtCount] = useState(getRandomBoughtCount(productsDetails.bought_count));
  const [viewCount, setViewCount] = useState(getRandomViewCount(productsDetails.view_count));
  // Update boughtCount when productsDetails.bought_count changes
  useEffect(() => {
    setBoughtCount(getRandomBoughtCount(productsDetails.bought_count));
    setViewCount(getRandomViewCount(productsDetails.view_count));
  }, [productsDetails.bought_count, productsDetails.view_count]);


  // New state for cross-selling products
  const [crossSellingProducts, setCrossSellingProducts] = useState([]);
  const [crossSellingLoading, setCrossSellingLoading] = useState(false);




  // Fetch cross-selling products
  useEffect(() => {
    const fetchCrossSellingProducts = async () => {
      const crossSellingIds = productsDetails.cross_selling_products
        ? productsDetails.cross_selling_products.split("|").filter((id) => id)
        : [];

      if (crossSellingIds.length === 0) {
        setCrossSellingProducts([]);
        return;
      }

      setCrossSellingLoading(true);
      try {
        const products = [];
        for (const product_auto_id of crossSellingIds) {
          const formData = new FormData();
          formData.append("admin_auto_id", admin_auto_id);
          formData.append("app_type_id", app_type_id);
          formData.append("user_auto_id", admin_auto_id);
          formData.append("product_auto_id", product_auto_id);
          formData.append("customer_auto_id", admin_auto_id);
          formData.append("sub_category_auto_id", admin_auto_id);

          const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/get_product_details`, {
            method: "POST",
            body: formData,
          });

          if (!response.ok) {
            console.error(`Failed to fetch product details for ID: ${product_auto_id}`);
            continue;
          }

          const responseData = await response.json();
          if (responseData?.get_products_details?.[0]) {
            products.push(responseData.get_products_details[0]);
          }
        }
        setCrossSellingProducts(products);
      } catch (error) {
        console.error("Error fetching cross-selling products:", error);
        setCrossSellingProducts([]);
      } finally {
        setCrossSellingLoading(false);
      }
    };

    if (productsDetails.cross_selling_products) {
      fetchCrossSellingProducts();
    }
  }, [productsDetails.cross_selling_products, admin_auto_id, app_type_id]);

  useEffect(() => {
    if (Array.isArray(data?.product_faqs)) {
      const formattedFaqs = data.product_faqs
        .filter(item => item?.question && item?.answer)
        .map(item => ({
          question: item.question,
          answer: item.answer,
        }));

      setFaqs(formattedFaqs);
      console.log("FAQs:", faqs);

    }
  }, [data]); // 👈 VERY IMPORTANT



  // useEffect(() => {
  //     const fetchCrossSellingProducts = async () => {
  //       setCrossSellingLoading(true);
  //       try {
  //         const formData = new FormData();
  //         formData.append("admin_auto_id", admin_auto_id);
  //         formData.append("app_type_id", app_type_id);
  //         formData.append("customer_auto_id", admin_auto_id);
  //         formData.append("product_auto_id", productsDetails.product_auto_id);
  //         formData.append("main_category_auto_id", productsDetails.main_category_auto_id);
  //         formData.append("sub_category_auto_id", productsDetails.sub_category_auto_id);
  //         const response = await fetch(
  //           `${process.env.REACT_APP_API_BASE_URL}/get_also_buy_products`,
  //           {
  //             method: "POST",
  //             body: formData,
  //           }
  //         );

  //         if (!response.ok) {
  //           console.error(
  //             `Failed to fetch cross-selling products for ID: ${productsDetails.product_auto_id}`
  //           );
  //           setCrossSellingProducts([]);
  //           return;
  //         }

  //         const responseData = await response.json();
  //         console.log("API Response:", responseData); // Log response for debugging
  //         if (responseData?.status === 1 && responseData.get_also_buy_product_lists) {
  //           setCrossSellingProducts(responseData.get_also_buy_product_lists);
  //         } else {
  //           console.error("No cross-selling products found in response:", responseData);
  //           setCrossSellingProducts([]);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching cross-selling products:", error);
  //         setCrossSellingProducts([]);
  //       } finally {
  //         setCrossSellingLoading(false);
  //       }
  //     };

  //     if (productsDetails?.product_auto_id && admin_auto_id && app_type_id) {
  //       fetchCrossSellingProducts();
  //     }
  //   }, [productsDetails?.product_auto_id, admin_auto_id, app_type_id]);



  return (
    <>
      <Helmet>
        {/* 🔹 Dynamic Title */}
        <title>
          {productsDetails?.product_name
            ? `${productsDetails.product_name} `
            : "Product Details"}
        </title>

        {/* 🔹 Meta Description */}
        <meta
          name="description"
          content={
            productsDetails?.description
              ? productsDetails.description
                .replace(/(<([^>]+)>)/gi, "")
              : "Buy products online at best price."
          }
        />

        {/* 🔹 Keywords */}
        <meta
          name="keywords"
          content={
            productsDetails?.keywords
              ? productsDetails.keywords
              : "online shopping, ecommerce product"
          }
        />



        {/* 🔹 PRODUCT SCHEMA (JSON-LD) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            name: productsDetails?.product_name,
            description: productsDetails?.description
              ?.replace(/(<([^>]+)>)/gi, "")
              .slice(0, 160),
            image: productsDetails?.product_images?.map(
              (img) =>
                `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${img.product_image}`
            ),
            offers: {
              "@type": "Offer",
              priceCurrency: "INR",
              price: productsDetails?.final_product_price,
              availability:
                productsDetails?.available_stock > 0
                  ? "https://schema.org/InStock"
                  : "https://schema.org/OutOfStock",
            },
          })}

        </script>





      </Helmet>
      <style>
        {`
          @keyframes wiggle {
            0%, 100% { transform: translateX(0); }
            25% { transform: translateX(-3px); }
            50% { transform: translateX(3px); }
            75% { transform: translateX(-3px); }
          }
          .wiggle {
            animation: wiggle 0.2s ease-in-out 3;
          }
          .disabled-overlay::after {
            content: "";
            position: absolute;
            top: 50%;
            left: 8%;
            right: 8%;
            height: 1px;
            background-color: #9ca3af; /* gray-400 */
            transform: translateY(-50%);
            pointer-events: none;
          }
        `}
      </style>
      <div className={`hidden md:block ${webFont}`}>
        <div className="justify-center m-2 md:flex items center">
          <div className="flex gap-6">
            {/* Left Section: Sticky Image Block */}
            <div className="w-[50%] sticky top-0 h-fit flex gap-4">
              {/* Thumbnails */}
              <div className="flex flex-col gap-3">
                {productImages.map((thumb) => (
                  <img
                    key={thumb.image_auto_id}
                    src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${thumb.product_image}`}
                    alt={`product_image ${thumb + 1}`}
                    className={`w-20 h-28 cursor-pointer ${mainImage === thumb ? "border-2 border-black" : "border"
                      }`}
                    onClick={() => setMainImage(thumb)}
                  />
                ))}
              </div>

              {/* Main Image */}
              <div
                className="relative flex items-center justify-center flex-1 overflow-hidden"
                onMouseMove={handleMouseMove}
                onClick={toggleZoom}
              >
                <img
                  src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${mainImage.product_image}`}
                  alt="Main Product"
                  className={`object-cover w-full h-screen max-w-none transition-transform duration-300 ${zoom ? "scale-150 cursor-zoom-out" : "cursor-zoom-in"
                    }`}
                  style={{
                    transformOrigin: `${zoomPosition.x}% ${zoomPosition.y}%`,
                  }}
                />
              </div>

            </div>

            {/* Right Column: Product Details */}
            <div className="w-[50%] overflow-y-auto space-y-4 p-5">
              <div className="flex flex-wrap items-start justify-between gap-2 sm:flex-nowrap">
                {/* Title */}
                <h2 className="flex-1 min-w-0 text-2xl font-bold break-words">
                  {productsDetails.product_name}
                </h2>

                {/* Wishlist button and message */}
                <div className="relative flex-shrink-0">
                  <button
                    onClick={handleWishlistToggle}
                    className={`p-1 rounded-full ${wishlisted ? "text-red-500" : "text-gray-500"} ${isVibrating ? "wiggle" : ""}`}
                    key={isVibrating ? `vibrate-${Date.now()}` : 'no-vibrate'}
                  >
                    {wishlisted ? (
                      <FaHeart className="w-6 h-6" />
                    ) : (
                      <FiHeart className="w-6 h-6" />
                    )}
                  </button>

                  {wishlistMessage.text && (
                    <div
                      className={`absolute -bottom-5 left-[-10rem] text-xs px-2 py-1 rounded bg-white z-10 whitespace-nowrap ${wishlistMessage.type === "error" ? "text-red-500" : "text-green-500"
                        }`}
                    >
                      {wishlistMessage.text}
                    </div>
                  )}
                </div>

              </div>



              <p className="mt-0 text-sm text-gray-500">
                {productsDetails.including_tax === "Yes"
                  ? "Inclusive of all taxes"
                  : "Exclusive of all taxes"}
              </p>
              <div className="space-y-1 text-gray-500">
                <p className="text-gray-500">
                  SKU: {formatSKU(productsDetails.product_model_auto_id)}
                </p>

                <div className="mt-1">
                  {showBought && isBoughtFactual && (
                    <p className="flex items-center text-sm font-medium font-extrabold text-black">
                      {boughtCount}+ bought this !
                    </p>
                  )}
                </div>

                <p className="text-xl font-semibold " style={{ color: themeColor }}>
                  ₹{currentPrice}
                  {parseInt(currentOffer) > 0 && (
                    <>
                      {" "}
                      <span className="ml-2 text-gray-400 line-through">
                        ₹{originalPrice}
                      </span>
                      <span className="px-2 py-1 ml-2 text-sm text-white" style={{ backgroundColor: themeColor }}>
                        {currentOffer}% OFF
                      </span>
                    </>
                  )}
                </p>
                <p className="text-black">Shipping calculated at checkout.</p>
              </div>

              {/* Sizes */}
              <div className="flex mt-4 space-x-2">
                {sizes.map((size, index) => {
                  const actualStock = parseInt(size.size_stock, 10);
                  const isDisabled = !actualStock || isNaN(actualStock) || actualStock <= 0;
                  const isSelected = selectedSize === size.size_name;

                  const displayStock = showStock ? randomStocks[index] : actualStock;
                  const showStockLabel =
                    actualStock > 0 && showStock && isQuantityLeftFactual && displayStock <= 5;

                  return (
                    <div key={size.product_auto_id} className="relative">
                      <button
                        className={`relative border w-20 h-12 text-sm flex items-center justify-center flex-col transition-colors duration-200 overflow-hidden
            ${isDisabled ? "bg-gray-200 text-gray-400 border-gray-300 cursor-not-allowed" : ""}
            ${!isDisabled && isSelected ? "text-white" : ""}
          `}
                        style={{
                          backgroundColor: !isDisabled && isSelected ? themeColor : undefined,
                          borderColor: !isDisabled && isSelected ? themeColor : undefined,
                          color: !isDisabled && isSelected ? "#ffffff" : undefined,
                        }}
                        onClick={() => !isDisabled && handleSizeSelect(size, index)}
                        onMouseEnter={(e) => {
                          if (!isSelected && !isDisabled) {
                            e.currentTarget.style.backgroundColor = themeColor;
                            e.currentTarget.style.color = "#ffffff";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!isSelected && !isDisabled) {
                            e.currentTarget.style.backgroundColor = "#ffffff";
                            e.currentTarget.style.color = "#000000";
                          }
                        }}
                        disabled={isDisabled}
                      >
                        {/* Size text */}
                        <span
                          className={`text-base leading-none ${showStockLabel ? "mb-3" : ""}`}
                        >
                          {size.size_name}
                        </span>

                        {/* Diagonal Slash Line When Disabled */}
                        {isDisabled && (
                          <span
                            className="absolute w-[130%] h-[1px] bg-gray-400 left-1/2 top-1/2 pointer-events-none"
                            style={{
                              transform: "translate(-50%, -50%) rotate(35deg)",
                            }}
                          ></span>
                        )}

                        {/* Stock label */}
                        {showStockLabel && (
                          <span
                            className="absolute bottom-0 left-0 right-0 px-2 py-[4px] text-[11px] text-center text-white leading-tight"
                            style={{ backgroundColor: themeColor }}
                          >
                            {displayStock} left
                          </span>
                        )}
                      </button>
                    </div>
                  );
                })}
              </div>


              {(chartImage || chartImage2) && (
                <button
                  className="mt-1 text-sm text-black underline"
                  onClick={toggleSizeGuideModal}
                >
                  View Size Guide
                </button>
              )}

              {/* Sidebar Modal */}
              {isSizeGuideModalOpen && (
                <div className="fixed inset-0 z-50 flex justify-end">
                  {/* Click Outside to Close */}
                  <div
                    className="flex-1 bg-black bg-opacity-50"
                    onClick={toggleSizeGuideModal}
                  ></div>

                  <div className="w-[360px] h-full bg-white shadow-lg p-6 overflow-y-auto relative transition-transform duration-300">
                    {/* Close Button */}
                    <button
                      onClick={toggleSizeGuideModal}
                      className="absolute text-gray-600 top-4 right-4 hover:text-black"
                    >
                      <X size={24} />
                    </button>

                    {/* Title */}
                    <h2 className="mb-2 text-2xl font-bold text-center">
                      Size Guide
                    </h2>

                    {/* Tabs */}
                    <div className="flex mb-4 border-b">
                      {["Size Chart", "International"].map((tab) => (
                        <button
                          key={tab}
                          onClick={() => setSelectedTab(tab)}
                          className={`flex-1 text-center py-2 font-semibold transition-all ${selectedTab === tab
                            ? "border-b-2"
                            : "text-gray-600"
                            }`}
                          style={{ color: selectedTab === tab ? themeColor : "", borderColor: selectedTab === tab ? themeColor : "" }}
                        >
                          {tab}
                        </button>
                      ))}
                    </div>

                    {/* Chart Content */}
                    {selectedTab === "Size Chart" && (
                      <div className="space-y-2">
                        {chartImage ? (
                          <img
                            src={chartImage}
                            alt="Size Chart"
                            className="w-full transition-transform duration-300 border rounded-md shadow-sm"
                          />
                        ) : (
                          <p className="text-sm text-center text-gray-500">
                            Chart not available.
                          </p>
                        )}
                      </div>
                    )}

                    {/* International Chart Content */}
                    {selectedTab === "International" && (
                      <div className="space-y-2">
                        {chartImage2 ? (
                          <img
                            src={chartImage2}
                            alt="International Size Chart"
                            className="w-full transition-transform duration-300 border rounded-md shadow-sm"
                          />
                        ) : (
                          <p className="text-sm text-center text-gray-500">
                            Internationalimage not available.
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Color */}
              {colors && colors.length > 0 && (
                <div className="space-y-2">
                  <p className="text-sm font-semibold">Color</p>
                  <div className="flex flex-col mt-3 space-y-1">
                    <div className="flex flex-wrap gap-2 mt-1">
                      {colors.map((color) => (
                        <Link
                          to={`/product-detail/${color.product_auto_id}`}
                          key={color.product_auto_id}
                          className="px-3 py-1 text-sm text-center text-black no-underline border border-black cursor-pointer"
                          title={color.color_name}
                        >
                          {color.color_name || "Color"}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* {colors && colors.length > 0 && (
                <div className="flex flex-col mt-4 space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                  Color:
                </label>
                  <div className="flex mt-2 space-x-3">
                    {colors.map((color) => {
                      const imageUrl = color.color_image
                        ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${color.color_image}`
                        : 'https://via.placeholder.com/400x400?text=No+Image';
                      return (
                        <Link
                          to={`/product-detail/${color.product_auto_id}`}
                          key={color.product_auto_id}
                          className="relative w-16 overflow-hidden transition-all duration-200 border-2 shadow-md cursor-pointer h-28"
                          title={color.color_name}
                          onClick={() => console.log(`Attempting to load image: ${imageUrl}`)}
                          style={{ borderColor: lightenHexColor(themeColor,0.2) }}
                        onMouseEnter={(e) => {
                          const darkenedColor = darkenHexColor(themeColor, 0.15); 
                          e.currentTarget.style.borderColor = darkenedColor;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = lightenHexColor(themeColor,0.2) ;
                        }}
                          
                        >
                          <img
                            src={imageUrl}
                            alt={color.color_name || 'Color Image'}
                            className="object-cover w-full h-full"
                            onError={(e) => {
                              console.error(`Failed to load image: ${imageUrl}`);
                              e.target.src = 'https://via.placeholder.com/400x400?text=Image+Failed';
                            }}
                          />
                          
                        </Link>
                      );
                    })}
                  </div>
                </div>
              )} */}

              {/* Availability */}
              {Number(productsDetails.available_stock) > 0 ? (
                <div className="flex items-center mt-3 space-x-2">
                  <span className="w-3 h-3 mb-3 bg-green-500 rounded-full"></span>
                  <p className="text-sm text-black">In stock, ready to ship</p>
                </div>
              ) : (
                <div className="flex items-center mt-3 space-x-2">
                  <span className="w-3 h-3 mb-3 bg-red-500 rounded-full"></span>
                  <p className="text-sm text-black">Out of stock</p>
                </div>
              )}

              <div className="mt-4">
                <p className="flex items-center font-semibold text-gray-500">
                  <FaMapMarkerAlt className="mr-2" size={18} /> Check
                  Availability
                </p>
                <div className="flex items-center mt-2">
                  <input
                    type="text"
                    placeholder="Enter pincode"
                    value={pincode}
                    onChange={handlePincodeChange}
                    className="w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                    maxLength={8} // Allow up to 8 digits
                    disabled={loading}
                  />
                </div>
                {loading && (
                  <p className="mt-2 text-sm font-medium text-gray-600">
                    Checking...
                  </p>
                )}
                {message && (
                  <p
                    className={`mt-2 text-sm font-medium ${messageColor}  p-2 `}
                  >
                    {message}
                  </p>
                )}
              </div>

              {/* Buttons */}
              <div className="flex flex-col space-y-2">
                {/* Change to flex-col and added space-y for spacing between buttons */}
                {/* Customize Now Dropdown */}

                {productsDetails.Customizable === "Yes" && (
                  <div className="relative w-[90%] mt-4">
                    <button
                      className="flex items-center justify-center w-full gap-2 px-6 py-3 text-black border-2 rounded-md"
                      onClick={() => setIsCustomizeOpen(!isCustomizeOpen)}
                    >
                      Customize Now
                      <RiArrowDropDownLine
                        className={`text-xl transition-transform ${isCustomizeOpen ? "rotate-180" : "rotate-0"
                          }`}
                      />
                    </button>

                    {isCustomizeOpen && (
                      <div className="mt-4 mb-2">
                        <p className="flex items-center font-semibold text-gray-500">
                          <span className="mr-2">📷</span> Customize Your
                          Product
                        </p>
                        <div className="p-4 mt-2 border border-gray-300 rounded-lg bg-gray-50">
                          <p className="mb-2 text-sm text-gray-600">
                            Upload an image to personalize your{" "}
                            {productsDetails.product_name}
                          </p>
                          <div className="flex items-center gap-4">
                            <input
                              type="file"
                              accept="image/*"
                              ref={fileInputRef}
                              onChange={handleImageUpload}
                              className="hidden"
                              id="image-upload"
                            />
                            <label
                              htmlFor="image-upload"
                              className="px-4 py-2 text-white transition duration-200 rounded-lg cursor-pointer "
                              style={{ backgroundColor: themeColor }}
                              onMouseEnter={(e) => {
                                const darkenedColor = lightenHexColor(themeColor, 0.1);
                                e.currentTarget.style.backgroundColor = darkenedColor;
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = themeColor;
                              }}
                            >
                              Choose Image
                            </label>
                            {imagePreview && (
                              <div className="flex items-center gap-2">
                                <img
                                  src={imagePreview}
                                  alt="Preview"
                                  className="object-cover w-16 h-16 border border-gray-300 rounded-md"
                                />
                                <button
                                  onClick={handleRemoveImage}
                                  className="p-1 text-red-500 transition bg-gray-100 rounded-full hover:text-red-700 hover:bg-gray-200"
                                  aria-label="Remove uploaded image"
                                >
                                  <FaTimes size={16} />
                                </button>
                              </div>
                            )}
                          </div>
                          {uploadedImage && (
                            <p className="mt-2 text-sm text-green-600">
                              Image uploaded: {uploadedImage.name}
                            </p>
                          )}
                          <p className="mt-2 text-xs text-gray-500">
                            Supported formats: JPG, PNG, GIF.
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className="relative">
                  <button
                    className={`border-2 px-6 py-3 w-[455px] rounded-md transition-all duration-300 ease-in-out text-white ${sizes?.length !== 0 && !selectedSize
                      ? "bg-gray-300  border-gray-300 cursor-not-allowed"
                      : ""
                      }`}
                    style={{ backgroundColor: sizes?.length > 0 && !selectedSize ? "" : themeColor, borderColor: sizes?.length > 0 && !selectedSize ? "" : themeColor }}
                    onMouseEnter={(e) => {
                      const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
                      e.currentTarget.style.backgroundColor = sizes?.length > 0 && !selectedSize ? "" : darkenedColor;
                      e.currentTarget.style.borderColor = sizes?.length > 0 && !selectedSize ? "" : darkenedColor;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = sizes?.length > 0 && !selectedSize ? "" : themeColor;
                      e.currentTarget.style.borderColor = sizes?.length > 0 && !selectedSize ? "" : themeColor;
                    }}
                    disabled={sizes?.length !== 0 && !selectedSize}
                    onClick={async () => {
                      if (sizes?.length === 0 || selectedSize) {
                        try {
                          const payload = {
                            product_auto_id: productsDetails?.product_auto_id,
                            added_by_id: productsDetails?.user_auto_id,
                            cart_quantity:
                              productsDetails?.moq && productsDetails.moq !== ""
                                ? productsDetails.moq
                                : 1,
                            ...(sizes?.length !== 0 && {
                              size: selectedSizeId,
                              size_price: currentPrice,
                            }),
                            ...(isCustomizable &&
                              uploadedImage && { cust_image: uploadedImage }),
                          };

                          const res = await addToCart(payload);

                          // 🚫 ALREADY IN CART → CHECK FIRST
                          if (res?.message && res.message.toLowerCase().includes("already")) {
                            setCartMessage({
                              text: "Product is already present in cart",
                              type: "error",
                            });
                            return; // ⛔ stop here, no navigation
                          }

                          // ✅ SUCCESS
                          if (res?.status === "1") {
                            setCartMessage({
                              text: res.message || "Added to cart",
                              type: "success",
                            });

                            setTimeout(() => {
                              navigate("/cart");
                            }, 1000);
                          } else {
                            setCartMessage({
                              text: res?.message || "Unable to add product to cart",
                              type: "error",
                            });
                          }

                        } catch (error) {
                          setCartMessage({ text: error.message || "Failed to add product to cart.", type: "error" });
                        }

                      } else {
                        setCartMessage({ text: "Select a Size", type: "error" });
                        return;
                      }
                    }}
                  >
                    {sizes?.length === 0 || selectedSize
                      ? `Add to Cart | ₹ ${currentPrice}`
                      : "SELECT A SIZE"}
                  </button>
                  {cartMessage.text && (
                    <div
                      className={`absolute left-0 right-0 bottom-[-2rem] text-center p-2 text-sm z-10 ${cartMessage.type === "error" ? "text-red-500" : "text-green-500"
                        }`}
                    >
                      {cartMessage.text}
                    </div>
                  )}

                  <div className="mt-2 space-y-2">
                    {showViews && isProductViewsFactual && (
                      <p className="flex items-center justify-center text-sm font-medium text-black">
                        <IoEyeSharp className="mr-1" size={18} />
                        {viewCount} people are viewing this item. Don’t wait!
                      </p>
                    )}
                  </div>

                </div>
              </div>

              {/* Additional Options */}
              <button className="mt-5 text-sm text-black underline ml-36">
                Specifications
              </button>

              {/* Specification */}
              {productsDetails.specification_details &&
                productsDetails.specification_details.length > 0 && (
                  <div className="space-y-2">
                    <ul className="pl-5 space-y-1 text-sm text-black list-disc">
                      {productsDetails.specification_details.map(
                        (spec, index) =>
                          spec.title &&
                          spec.description && (
                            <li key={index}>
                              <span className="font-medium">
                                {spec.title}:{" "}
                              </span>
                              <span>{spec.description}</span>
                            </li>
                          )
                      )}
                    </ul>
                  </div>
                )}

              <div>
                {/* Shipping Information */}
                {productsDetails && (
                  <div className="w-full max-w-md mb-0">
                    <button
                      className="flex items-center justify-center w-full gap-0 p-3 text-sm font-medium text-black border border-gray-500"
                      onClick={() => setIsShippingOpen(!isShippingOpen)}
                    >
                      <span className="flex-1 tracking-wider text-center">
                        S H I P P I N G &nbsp; I N F O R M A T I O N
                      </span>
                      <RiArrowDropDownLine
                        className={`text-xl transition-transform ${isShippingOpen ? "rotate-180" : "rotate-0"
                          }`}
                      />
                    </button>

                    {isShippingOpen && (
                      <div className="p-3 mt-2 space-y-2 text-sm text-gray-700">
                        {productsDetails.Trial_Period && (
                          <p>Trial Period: {productsDetails.Trial_Period}</p>
                        )}
                        {productsDetails.isReturn === "Yes" && (
                          <p>
                            Returns accepted within {productsDetails.days}{" "}
                            {productsDetails.time_unit.toLowerCase()}.
                          </p>
                        )}
                        {productsDetails.isExchange === "Yes" && (
                          <p>
                            Exchanges allowed within {productsDetails.days}{" "}
                            {productsDetails.time_unit.toLowerCase()}.
                          </p>
                        )}
                        <p>Estimated delivery: 5–7 business days.</p>
                      </div>
                    )}
                  </div>
                )}

                {/* Return  Policy */}
                {productsDetails && (
                  <div className="w-full max-w-md mb-0">
                    <button
                      className="flex items-center justify-center w-full gap-0 p-3 text-sm font-medium text-black border border-gray-500"
                      onClick={() => setIsRefundOpen(!isRefundOpen)}
                    >
                      <span className="flex-1 tracking-wider text-center">
                        R E T U R N &nbsp; / &nbsp; R E F U N D &nbsp; P O L I C
                        Y
                      </span>
                      <RiArrowDropDownLine
                        className={`text-xl transition-transform ${isRefundOpen ? "rotate-180" : "rotate-0"
                          }`}
                      />
                    </button>
                    {isRefundOpen && (
                      <div className="p-3 mt-2 space-y-2 text-sm text-gray-700">
                        {productsDetails.isReturn === "Yes" ? (
                          <p>
                            This product is eligible for return within{" "}
                            {productsDetails.days}{" "}
                            {productsDetails.time_unit?.toLowerCase() || "days"}{" "}
                            from the date of delivery.
                          </p>
                        ) : (
                          <p>This product is not eligible for return.</p>
                        )}

                        {productsDetails.isExchange === "Yes" && (
                          <p>
                            Exchange is available for this product under the
                            same period.
                          </p>
                        )}
                        <p>
                          For refund/exchange inquiries, please contact our
                          support team with your order ID.
                        </p>
                      </div>
                    )}
                  </div>
                )}

                {/* Ask a Question */}
                {/* <div className="w-full max-w-md mb-0">
              <button
                className="flex items-center justify-center w-full gap-0 p-3 text-sm font-medium text-black border border-gray-500"
                onClick={() => setIsQuestionOpen(!isQuestionOpen)}
              >
                <span className="flex-1 tracking-wider text-center ">
                  A S K &nbsp; A &nbsp; Q U E S T I O N
                </span>
                <RiArrowDropDownLine
                  className={`text-xl transition-transform ${
                    isQuestionOpen ? "rotate-180" : "rotate-0"
                  }`}
                />
              </button>
              {isQuestionOpen && (
                <div className="p-3 mt-2 text-sm text-gray-700">
                  <p>
                    If you have any questions, feel free to reach out to our
                    support team.
                  </p>
                </div>
              )}
            </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className={`block p-4 space-y-4 md:hidden ${webFont}`}>
        <div className="w-full">
          <img
            src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${mainImage.product_image}`}
            alt="Main Product"
            className="object-cover w-full h-96"
          />
        </div>
        <div className="space-y-2">
          <div className="flex items-start justify-between gap-2">
            <h2 className="flex-1 min-w-0 text-xl font-bold break-words">
              {productsDetails.product_name}
            </h2>

            <div className="relative flex-shrink-0">
              <button
                onClick={handleWishlistToggle}
                className={`p-1 rounded-full ${wishlisted ? "text-red-500" : "text-gray-500"} ${isVibrating ? "wiggle" : ""}`}
                key={isVibrating ? `vibrate-${Date.now()}` : 'no-vibrate'}
              >
                {wishlisted ? (
                  <FaHeart className="w-6 h-6" />
                ) : (
                  <FiHeart className="w-6 h-6" />
                )}
              </button>
              {wishlistMessage.text && (
                <div
                  className={`absolute -bottom-5 left-[-10rem] text-xs px-2 py-1 rounded bg-white z-10 whitespace-nowrap ${wishlistMessage.type === "error" ? "text-red-500" : "text-green-500"
                    }`}
                >
                  {wishlistMessage.text}
                </div>
              )}
            </div>
          </div>
          <p className="mt-0 text-sm text-gray-500">
            {productsDetails.including_tax === "Yes"
              ? "Inclusive of all taxes"
              : "Exclusive of all taxes"}
          </p>
          <p className="text-sm text-gray-500">
            SKU:  {formatSKU(productsDetails.product_model_auto_id)}
          </p>

          <div className="mt-1">
            {showBought && isBoughtFactual && (
              <p className="flex items-center text-sm font-medium font-extrabold text-black">
                {boughtCount}+ bought this !
              </p>
            )}
          </div>

          <p className="text-xl font-semibold" style={{ color: themeColor }}>
            ₹{currentPrice}
            {parseInt(currentOffer) > 0 && (
              <>
                <span className="ml-2 text-gray-400 line-through">
                  ₹ {originalPrice}
                </span>
                <span className="px-2 py-1 ml-2 text-sm text-white " style={{ backgroundColor: themeColor }}>
                  {currentOffer}% OFF
                </span>
              </>
            )}
          </p>
          <p className="text-sm text-black">Shipping calculated at checkout.</p>
        </div>
        <div className="flex flex-wrap gap-2">
          {sizes.map((size, index) => {
            const actualStock = parseInt(size.size_stock, 10);
            const isDisabled = !actualStock || isNaN(actualStock) || actualStock <= 0;
            const isSelected = selectedSize === size.size_name;

            const displayStock = showStock ? randomStocks[index] : actualStock;
            const showStockLabel =
              actualStock > 0 && showStock && isQuantityLeftFactual && displayStock <= 5;

            return (
              <div key={size.product_auto_id} className="relative">
                <button
                  className={`relative border sm:w-10 w-10 h-12 text-sm flex items-center justify-center flex-col transition-colors duration-200 overflow-hidden
            ${isDisabled ? "bg-gray-200 text-gray-400 border-gray-300 cursor-not-allowed" : ""}
            ${!isDisabled && isSelected ? "text-white" : ""}
          `}
                  style={{
                    backgroundColor: !isDisabled && isSelected ? themeColor : undefined,
                    borderColor: !isDisabled && isSelected ? themeColor : undefined,
                    color: !isDisabled && isSelected ? "#ffffff" : undefined,
                  }}
                  onClick={() => !isDisabled && handleSizeSelect(size, index)}
                  onMouseEnter={(e) => {
                    if (!isSelected && !isDisabled) {
                      e.currentTarget.style.backgroundColor = themeColor;
                      e.currentTarget.style.color = "#ffffff";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isSelected && !isDisabled) {
                      e.currentTarget.style.backgroundColor = "#ffffff";
                      e.currentTarget.style.color = "#000000";
                    }
                  }}
                  disabled={isDisabled}
                >
                  {/* Size Label */}
                  <span
                    className={`text-base leading-none ${showStockLabel ? "mb-3" : ""}`}
                  >
                    {size.size_name}
                  </span>

                  {/* 🔥 Diagonal Slash Line for Disabled Sizes */}
                  {isDisabled && (
                    <span
                      className="absolute w-[140%] h-[1px] bg-gray-400 left-1/2 top-1/2 pointer-events-none"
                      style={{
                        transform: "translate(-50%, -50%) rotate(35deg)",
                      }}
                    ></span>
                  )}

                  {/* Stock Label */}
                  {showStockLabel && (
                    <span
                      className="absolute bottom-0 left-0 right-0 px-2 py-[4px] text-[11px] text-center text-white leading-tight"
                      style={{ backgroundColor: themeColor }}
                    >
                      {displayStock} left
                    </span>
                  )}
                </button>
              </div>
            );
          })}
        </div>

        {(chartImage || chartImage2) && (
          <button
            className="mt-1 text-sm text-black underline"
            onClick={toggleSizeGuideModal}
          >
            View Size Guide
          </button>
        )}
        {isSizeGuideModalOpen && (
          <div className="fixed inset-0 z-50 flex items-end bg-black bg-opacity-50">
            <div className="w-full max-h-[80%] bg-white rounded-t-2xl shadow-lg p-4 overflow-y-auto relative">
              <button
                onClick={toggleSizeGuideModal}
                className="absolute text-gray-600 top-4 right-4 hover:text-black"
              >
                <X size={24} />
              </button>
              <h2 className="mb-4 text-lg font-bold text-center">Size Guide</h2>
              <div className="flex mb-4 border-b">
                {["Size Chart", "International"].map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setSelectedTab(tab)}
                    className={`flex-1 text-center py-2 font-semibold transition-all ${selectedTab === tab
                      ? "border-b-2 "
                      : "text-gray-600"
                      }`}
                    style={{ color: selectedTab === tab ? themeColor : "", borderColor: selectedTab === tab ? themeColor : "" }}
                  >
                    {tab}
                  </button>
                ))}
              </div>
              {selectedTab === "Size Chart" && (
                <div className="space-y-2">
                  {chartImage ? (
                    <img
                      src={chartImage}
                      alt="Size Chart"
                      className="w-full border rounded shadow-sm"
                    />
                  ) : (
                    <p className="text-sm text-center text-gray-500">
                      Chart not available.
                    </p>
                  )}
                </div>
              )}
              {selectedTab === "International" && (
                <div className="space-y-2">
                  {chartImage2 ? (
                    <img
                      src={chartImage2}
                      alt="International Size Chart"
                      className="w-full border rounded shadow-sm"
                    />
                  ) : (
                    <p className="text-sm text-center text-gray-500">
                      International image not available.
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
        {colors && colors.length > 0 && (
          <div className="space-y-1">
            <p className="text-sm font-medium">Color:</p>
            <div className="flex flex-wrap gap-2">
              {colors.map((color) => (
                <Link
                  to={`/product-detail/${color.product_auto_id}`}
                  key={color.product_auto_id}
                  className="px-3 py-1 text-sm text-black border border-black"
                >
                  {color.color_name}
                </Link>
              ))}
            </div>
          </div>
        )}

        {/* {colors && colors.length > 0 && (
                <div className="flex flex-col mt-4 space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                  Color:
                </label>
                  <div className="flex mt-2 space-x-3">
                    {colors.map((color) => {
                      const imageUrl = color.color_image
                        ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${color.color_image}`
                        : 'https://via.placeholder.com/400x400?text=No+Image';
                      return (
                        <Link
                          to={`/product-detail/${color.product_auto_id}`}
                          key={color.product_auto_id}
                          className="relative w-16 overflow-hidden transition-all duration-200 border-2 shadow-md cursor-pointer h-28"
                          title={color.color_name}
                          onClick={() => console.log(`Attempting to load image: ${imageUrl}`)}
                          style={{ borderColor: lightenHexColor(themeColor,0.2) }}
                        onMouseEnter={(e) => {
                          const darkenedColor = darkenHexColor(themeColor, 0.15); 
                          e.currentTarget.style.borderColor = darkenedColor;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = lightenHexColor(themeColor,0.2) ;
                        }}
                          
                        >
                          <img
                            src={imageUrl}
                            alt={color.color_name || 'Color Image'}
                            className="object-cover w-full h-full"
                            onError={(e) => {
                              console.error(`Failed to load image: ${imageUrl}`);
                              e.target.src = 'https://via.placeholder.com/400x400?text=Image+Failed';
                            }}
                          />
                          
                        </Link>
                      );
                    })}
                  </div>
                </div>
              )} */}

        {Number(productsDetails.available_stock) > 0 ? (
          <div className="flex items-center mt-3 space-x-2">
            <span className="w-3 h-3 mb-3 bg-green-500 rounded-full"></span>
            <p className="text-sm text-black">In stock, ready to ship</p>
          </div>
        ) : (
          <div className="flex items-center mt-3 space-x-2">
            <span className="w-3 h-3 mb-3 bg-red-500 rounded-full"></span>
            <p className="text-sm text-black">Out of stock</p>
          </div>
        )}

        <div className="mt-4">
          <p className="flex items-center font-semibold text-gray-500">
            <FaMapMarkerAlt className="mr-2" size={18} /> Check Availability
          </p>
          <div className="flex items-center mt-2">
            <input
              type="text"
              placeholder="Enter pincode"
              value={pincode}
              onChange={handlePincodeChange}
              className="w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-black"
              maxLength={8} // Allow up to 8 digits
              disabled={loading}
            />
          </div>
          {loading && (
            <p className="mt-2 text-sm font-medium text-gray-600">
              Checking...
            </p>
          )}
          {message && (
            <p className={`mt-2 text-sm font-medium ${messageColor}  p-2 `}>
              {message}
            </p>
          )}
        </div>

        {productsDetails.Customizable === "Yes" && (
          <div className="relative w-[90%] mt-4">
            <button
              className="flex items-center justify-center w-full gap-2 px-6 py-3 text-black border-2 rounded-md"
              onClick={() => setIsCustomizeOpen(!isCustomizeOpen)}
            >
              Customize Now
              <RiArrowDropDownLine
                className={`text-xl transition-transform ${isCustomizeOpen ? "rotate-180" : "rotate-0"
                  }`}
              />
            </button>

            {isCustomizeOpen && (
              <div className="mt-4 mb-2">
                <p className="flex items-center font-semibold text-gray-500">
                  <span className="mr-2">📷</span> Customize Your Product
                </p>
                <div className="p-4 mt-2 border border-gray-300 rounded-lg bg-gray-50">
                  <p className="mb-2 text-sm text-gray-600">
                    Upload an image to personalize your{" "}
                    {productsDetails.product_name}
                  </p>
                  <div className="flex items-center gap-4">
                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRef}
                      onChange={handleImageUpload}
                      className="hidden"
                      id="image-upload"
                    />
                    <label
                      htmlFor="image-upload"
                      className="px-4 py-2 text-white transition duration-200 rounded-lg cursor-pointer "
                      style={{ backgroundColor: themeColor }}
                      onMouseEnter={(e) => {
                        const darkenedColor = lightenHexColor(themeColor, 0.1);
                        e.currentTarget.style.backgroundColor = darkenedColor;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = themeColor;
                      }}
                    >
                      Choose Image
                    </label>
                    {imagePreview && (
                      <div className="flex items-center gap-2">
                        <img
                          src={imagePreview}
                          alt="Preview"
                          className="object-cover w-16 h-16 border border-gray-300 rounded-md"
                        />
                        <button
                          onClick={handleRemoveImage}
                          className="p-1 text-red-500 transition bg-gray-100 rounded-full hover:text-red-700 hover:bg-gray-200"
                          aria-label="Remove uploaded image"
                        >
                          <FaTimes size={16} />
                        </button>
                      </div>
                    )}
                  </div>
                  {uploadedImage && (
                    <p className="mt-2 text-sm text-green-600">
                      Image uploaded: {uploadedImage.name}
                    </p>
                  )}
                  <p className="mt-2 text-xs text-gray-500">
                    Supported formats: JPG, PNG, GIF.
                  </p>
                </div>
              </div>
            )}
          </div>
        )}
        <div className="relative">
          <button
            className={`w-full py-3 rounded-md text-white ${sizes?.length !== 0 && !selectedSize
              ? "bg-gray-400"
              : ""
              }`}
            style={{ backgroundColor: sizes?.length > 0 && !selectedSize ? "" : themeColor, borderColor: sizes?.length > 0 && !selectedSize ? "" : themeColor }}
            onMouseEnter={(e) => {
              const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
              e.currentTarget.style.backgroundColor = sizes?.length > 0 && !selectedSize ? "" : darkenedColor;
              e.currentTarget.style.borderColor = sizes?.length > 0 && !selectedSize ? "" : darkenedColor;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = sizes?.length > 0 && !selectedSize ? "" : themeColor;
              e.currentTarget.style.borderColor = sizes?.length > 0 && !selectedSize ? "" : themeColor;
            }}
            disabled={sizes?.length !== 0 && !selectedSize}
            onClick={async () => {
              if (sizes?.length === 0 || selectedSize) {
                try {
                  const payload = {
                    product_auto_id: productsDetails?.product_auto_id,
                    added_by_id: productsDetails?.user_auto_id,
                    cart_quantity:
                      productsDetails?.moq && productsDetails.moq !== ""
                        ? productsDetails.moq
                        : 1,
                    ...(sizes?.length !== 0 && {
                      size: selectedSizeId,
                      size_price: currentPrice,
                    }),
                    ...(isCustomizable &&
                      uploadedImage && { cust_image: uploadedImage }),
                  };

                  const res = await addToCart(payload);

                  // 🚫 ALREADY IN CART → CHECK FIRST
                  if (res?.message && res.message.toLowerCase().includes("already")) {
                    setCartMessage({
                      text: "Product is already present in cart",
                      type: "error",
                    });
                    return; // ⛔ stop here, no navigation
                  }

                  // ✅ SUCCESS
                  if (res?.status === "1") {
                    setCartMessage({
                      text: res.message || "Added to cart",
                      type: "success",
                    });

                    setTimeout(() => {
                      navigate("/cart");
                    }, 1000);
                  } else {
                    setCartMessage({
                      text: res?.message || "Unable to add product to cart",
                      type: "error",
                    });
                  }

                } catch (error) {
                  setCartMessage({ text: error.message || "Failed to add product to cart.", type: "error" });
                }

              } else {
                setCartMessage({ text: "Select a Size", type: "error" });
                return;
              }
            }}
          >
            {sizes?.length === 0 || selectedSize
              ? `Add to Cart | ₹ ${currentPrice}`
              : "SELECT A SIZE"}
          </button>
          {cartMessage.text && (
            <div
              className={`absolute left-0 right-0 bottom-[-2rem] text-center p-2 text-sm z-10 ${cartMessage.type === "error" ? "text-red-500" : "text-green-500"
                }`}
            >
              {cartMessage.text}
            </div>
          )}

          <div className="mt-2 space-y-2">

            {showViews && isProductViewsFactual && (
              <p className="flex items-center justify-center text-sm font-medium text-black">
                <IoEyeSharp className="mr-1" size={18} />
                {viewCount} people are viewing this item. Don’t wait!
              </p>
            )}
          </div>
        </div>
        <div>
          <button
            className="flex items-center justify-between w-full p-3 text-sm font-medium text-left border"
            onClick={() => setIsShippingOpen(!isShippingOpen)}
          >
            SHIPPING INFORMATION
            <RiArrowDropDownLine
              className={`text-xl transition-transform ${isShippingOpen ? "rotate-180" : "rotate-0"
                }`}
            />
          </button>
          {isShippingOpen && (
            <div className="p-3 text-sm border border-t-0">
              {productsDetails.Trial_Period && (
                <p>Trial Period: {productsDetails.Trial_Period}</p>
              )}
              {productsDetails.isReturn === "Yes" && (
                <p>
                  Returns accepted within {productsDetails.days}{" "}
                  {productsDetails.time_unit.toLowerCase()}.
                </p>
              )}
              {productsDetails.isExchange === "Yes" && (
                <p>
                  Exchanges allowed within {productsDetails.days}{" "}
                  {productsDetails.time_unit.toLowerCase()}.
                </p>
              )}
              <p>Estimated delivery: 5–7 business days.</p>
            </div>
          )}
        </div>
        <div>
          <button
            className="flex items-center justify-between w-full p-3 text-sm font-medium text-left border"
            onClick={() => setIsRefundOpen(!isRefundOpen)}
          >
            RETURN / REFUND POLICY
            <RiArrowDropDownLine
              className={`text-xl transition-transform ${isRefundOpen ? "rotate-180" : "rotate-0"
                }`}
            />
          </button>
          {isRefundOpen && (
            <div className="p-3 text-sm border border-t-0">
              {productsDetails.isReturn === "Yes" ? (
                <p>
                  Eligible for return within {productsDetails.days}{" "}
                  {productsDetails.time_unit?.toLowerCase() || "days"}.
                </p>
              ) : (
                <p>This product is not eligible for return.</p>
              )}
              {productsDetails.isExchange === "Yes" && (
                <p>Exchange available during the return period.</p>
              )}
              <p>Contact support with your order ID for assistance.</p>
            </div>
          )}
        </div>
        {productsDetails.specification_details &&
          productsDetails.specification_details.length > 0 && (
            <div className="space-y-2">
              <h3 className="text-sm font-medium">Specifications</h3>
              <ul className="pl-5 space-y-1 text-sm text-black list-disc">
                {productsDetails.specification_details.map((spec, index) =>
                  spec.title && spec.description ? (
                    <li key={index}>
                      <span className="font-medium">{spec.title}: </span>
                      <span>{spec.description}</span>
                    </li>
                  ) : null
                )}
              </ul>
            </div>
          )}
      </div>

      {/* Testimonials Section */}
      {reviews.length > 0 && (
        <div className={`m-8 mt-14 ${webFont}`}>
          <h2 className="mb-4 text-xl font-semibold text-center">Reviews</h2>
          <div className="relative">
            {/* Desktop: Grid layout with 3 reviews */}
            <div
              className="hidden md:block"
              ref={sliderRef}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              <div className="grid grid-cols-3 gap-6">
                {reviews
                  .slice(currentReviewIndex, currentReviewIndex + 3)
                  .map((review) => (
                    <div
                      key={review.rating_auto_id}
                      className="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-lg"
                    >
                      <div className="flex justify-center mb-2">
                        {[...Array(5)].map((_, i) => (
                          <svg
                            key={i}
                            className={`w-5 h-5 ${i < review.rating
                              ? "text-yellow-400"
                              : "text-gray-300"
                              }`}
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.97a1 1 0 00.95.69h4.15c.969 0 1.371 1.24.588 1.81l-3.357 2.44a1 1 0 00-.364 1.118l1.287 3.97c.3.921-.755 1.688-1.54 1.118l-3.357-2.44a1 1 0 00-1.175 0l-3.357 2.44c-.784.57-1.838-.197-1.54-1.118l1.287-3.97a1 1 0 00-.364-1.118L2.273 9.397c-.784-.57-.38-1.81.588-1.81h4.15a1 1 0 00.95-.69l1.286-3.97z" />
                          </svg>
                        ))}
                      </div>
                      <p className="mb-4 italic text-center text-gray-700">
                        "{review.review}"
                      </p>
                      <p className="text-sm text-center text-gray-500">
                        — {review.customer_name}
                      </p>
                    </div>
                  ))}
              </div>
            </div>

            {/* Mobile: Single review slider */}
            <div
              className="block md:hidden"
              ref={sliderRef}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              <div className="overflow-hidden">
                <div
                  className="flex transition-transform duration-500"
                  style={{
                    transform: `translateX(-${currentReviewIndex * 100}%)`,
                  }}
                >
                  {reviews.map((review) => (
                    <div
                      key={review.rating_auto_id}
                      className="flex justify-center min-w-full"
                    >
                      <div className="flex flex-col items-center justify-center w-full p-6 bg-white rounded-lg shadow-lg">
                        <div className="flex justify-center mb-2">
                          {[...Array(5)].map((_, i) => (
                            <svg
                              key={i}
                              className={`w-5 h-5 ${i < review.rating
                                ? "text-yellow-400"
                                : "text-gray-300"
                                }`}
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.97a1 1 0 00.95.69h4.15c.969 0 1.371 1.24.588 1.81l-3.357 2.44a1 1 0 00-.364 1.118l1.287 3.97c.3.921-.755 1.688-1.54 1.118l-3.357-2.44a1 1 0 00-1.175 0l-3.357 2.44c-.784.57-1.838-.197-1.54-1.118l1.287-3.97a1 1 0 00-.364-1.118L2.273 9.397c-.784-.57-.38-1.81.588-1.81h4.15a1 1 0 00.95-.69l1.286-3.97z" />
                            </svg>
                          ))}
                        </div>
                        <p className="mb-4 italic text-center text-gray-700">
                          "{review.review}"
                        </p>
                        <p className="text-sm text-center text-gray-500">
                          — {review.customer_name}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Navigation Dots */}
            {reviews.length > reviewsPerPage && (
              <div className="flex justify-center mt-4 space-x-2">
                {Array.from({ length: totalPages }).map((_, index) => (
                  <button
                    key={index}
                    onClick={() => goToReview(index)}
                    className={`w-3 h-3 rounded-full ${Math.floor(currentReviewIndex / reviewsPerPage) === index
                      ? "bg-black"
                      : "bg-gray-300"
                      }`}
                  ></button>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      <div className={`m-8 ${webFont}`}>
        <h2 className="mb-4 text-xl font-semibold">SIMILAR PRODUCTS</h2>

        {/* MOBILE: 3 cards horizontally | DESKTOP: grid */}
        <div
          className="flex gap-3 overflow-x-auto scrollbar-none sm:grid sm:grid-cols-3 sm:gap-4 md:grid md:grid-cols-4"
        >
          {allProducts?.map((product) => {
            const discount =
              product.product_price && product.final_product_price
                ? Math.round(
                  ((product.product_price - product.final_product_price) /
                    product.product_price) *
                  100
                )
                : 0;

            return (
              <Link
                to={`/product-detail/${product.product_auto_id}`}
                key={product.product_auto_id}
                className="
            text-black no-underline 
            min-w-[33.33%]   
            sm:min-w-0
          "
              >
                <div className="bg-white">
                  <div className="relative">
                    {product.new_arrival === "Yes" && (
                      <div
                        className="absolute px-2 py-1 text-xs text-white top-2 left-2"
                        style={{ backgroundColor: themeColor }}
                      >
                        New Arrival
                      </div>
                    )}

                    <img
                      src={
                        product.product_images?.[0]?.product_image &&
                          product.product_images[0].product_image.trim() !== ""
                          ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${product.product_images[0].product_image}`
                          : "https://placehold.co/300x400"
                      }
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "https://placehold.co/300x400";
                      }}
                      alt={product.product_name}
                      className="object-cover w-full h-46 sm:h-72"
                    />

                  </div>

                  <div className="p-2">
                    <h3 className="text-sm font-medium truncate">
                      {product.product_name}
                    </h3>

                    <div className="mt-1 text-sm">
                      <span
                        className="font-semibold"
                        style={{ color: themeColor }}
                      >
                        ₹{product.final_product_price}
                      </span>

                      {discount > 0 && (
                        <span className="ml-2 text-gray-400 line-through">
                          ₹{product.product_price}
                        </span>
                      )}

                      {discount > 0 && (
                        <span
                          className="ml-2 text-xs font-medium"
                          style={{ color: themeColor }}
                        >
                          ({discount}% OFF)
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>



      {crossSellingProducts.length > 0 && (
        <div className={`m-8 ${webFont}`}>
          <h2 className="mb-4 text-xl font-semibold">YOU MAY ALSO BUY</h2>
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
            {crossSellingProducts?.map((product) => {
              const discount =
                product.product_price && product.final_product_price
                  ? Math.round(
                    ((product.product_price - product.final_product_price) /
                      product.product_price) *
                    100
                  )
                  : 0;

              return (
                <Link
                  to={`/product-detail/${product.product_auto_id}`}
                  key={product.product_auto_id}
                  className="text-black no-underline"
                >
                  <div key={product.product_auto_id} className="bg-white">
                    <div className="relative">
                      {product.new_arrival === "Yes" && (
                        <div className="absolute px-2 py-1 text-xs text-white top-2 left-2"
                          style={{ backgroundColor: themeColor }}>
                          New Arrival
                        </div>
                      )}
                      <img
                        src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${product.product_images[0].product_image}`}
                        alt={product.product_name}
                        className="object-cover w-full h-72"
                      />
                    </div>
                    <div className="p-2">
                      <h3 className="text-sm font-medium truncate">
                        {product.product_name}
                      </h3>
                      <div className="mt-1 text-sm">
                        <span className="font-semibold "
                          style={{ color: themeColor }}>
                          ₹{product.final_product_price}
                        </span>
                        {discount > 0 && (
                          <span className="ml-2 text-gray-400 line-through">
                            ₹{product.product_price}
                          </span>
                        )}

                        {discount > 0 && (
                          <span className="ml-2 text-xs font-medium "
                            style={{ color: themeColor }}>
                            ({discount}% OFF)
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      )}
      {faqs.length > 0 && (
        <section className="faq-section">
          <h2 className="faq-title">Frequently Asked Questions</h2>

          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <h3 className="faq-question">{faq.question}</h3>
              <p className="faq-answer">{faq.answer}</p>
            </div>
          ))}
        </section>
      )}

      {faqs.length > 0 && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: faqs.map(faq => ({
                "@type": "Question",
                name: faq.question,
                acceptedAnswer: {
                  "@type": "Answer",
                  text: faq.answer,
                },
              })),
            }),
          }}
        />
      )}
    </>
  );
};

export default ProductDetail3;